import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { Ic } from "../icons.jsx";
import { STEPS, PAGE_SEO, breadcrumb } from "../data.js";
import CtaBand from "../components/CtaBand.jsx";
import GuideLinks from "../components/GuideLinks.jsx";
import Breadcrumb from "../components/Breadcrumb.jsx";

const ADMIN_FEATURES = [
  { i:"car",   c:"",  t:"Aggiungi veicoli",       d:"Scheda completa con marca, modello, targa, foto, categoria e prezzo per ogni giorno della settimana." },
  { i:"cal",   c:"g", t:"Gestisci prenotazioni",  d:"Visualizza tutto in un colpo. Conferma ritiri, gestisci riconsegne e aggiorna lo stato in tempo reale." },
  { i:"pdf",   c:"g", t:"Stampa contratti",       d:"Un click e generi il contratto PDF firmabile con tutti i dati del cliente, del veicolo e del periodo." },
  { i:"chart", c:"g", t:"Statistiche e ricavi",   d:"Ricavi mensili, veicolo più noleggiato, prenotazioni per categoria, split online vs cassa." },
  { i:"tag",   c:"a", t:"Crea codici sconto",     d:"Promozioni con sconto percentuale o fisso, limite utilizzi, date di validità e importo minimo." },
  { i:"users", c:"a", t:"Gestisci il team",       d:"Aggiungi più operatori al pannello admin. Ciascuno ha accesso completo alla dashboard." },
];

export default function ComeFunziona({ go }) {
  useAnim();
  const BC_ITEMS = [{ name:"Come Funziona", path:"/come-funziona" }];
  useSEO({ ...PAGE_SEO["come-funziona"], schema: breadcrumb(BC_ITEMS) });

  return (
    <>
      <Breadcrumb items={BC_ITEMS} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Come funziona</div>
          <h1 className="h2" style={{ fontSize:"clamp(1.9rem,4vw,2.9rem)" }}>
            Operativo in <mark>meno di un'ora</mark>
          </h1>
          <p className="lead" style={{ marginTop:".65rem" }}>
            Nessuna configurazione tecnica, nessun codice da scrivere.
            Segui i quattro passi e il tuo noleggio è online.
          </p>
        </div>
      </section>

      {/* Steps */}
      <section className="sec" style={{ background:"var(--bg)" }}>
        <div className="wrap">
          <div className="sg">
            {STEPS.map((s, i) => (
              <div className={`sc-card an d${i + 1}`} key={s.n}>
                <div className="snum j">{s.n}</div>
                <div className="sb"><h3>{s.t}</h3><p>{s.d}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Admin panel features */}
      <section className="sec">
        <div className="wrap">
          <div className="tc an" style={{ marginBottom:"3rem" }}>
            <div className="chip a">Dashboard admin</div>
            <h2 className="h2">Gestisci tutto<br /><mark>dal pannello</mark></h2>
            <p className="lead c">
              Un'unica interfaccia per veicoli, prenotazioni, clienti, statistiche e impostazioni.
            </p>
          </div>
          <div className="fg">
            {ADMIN_FEATURES.map((f, i) => (
              <article className={`fc an d${(i % 3) + 1}`} key={f.t}>
                <div className={`fi ${f.c}`}><Ic n={f.i} s={21} /></div>
                <h3 className="ft">{f.t}</h3>
                <p className="fd">{f.d}</p>
              </article>
            ))}
          </div>

          <div className="an" style={{ textAlign: "center", marginTop: "3rem" }}>
            <Link to="/tutorial" className="btn btn-o" style={{ textDecoration: "none" }}>
              Segui i tutorial →
            </Link>
          </div>
        </div>
      </section>

      <GuideLinks />

      <CtaBand go={go} />
    </>
  );
}
